import React, { useEffect, useRef, useState } from "react"

const reveal = target => {
  if (!target) return
  const toolbar = target.closest(".competition-main-draw")?.querySelector(".main-draw-toolbar--pinned")
  // The pinned controls wrap on mobile; position the match below their actual height.
  const offset = toolbar ? toolbar.getBoundingClientRect().height + (parseFloat(getComputedStyle(toolbar).top) || 0) : 0
  target.style.scrollMarginTop = `${offset + 16}px`
  target.scrollIntoView?.({ block: "start", inline: "center", behavior: "auto" })
  target?.focus({ preventScroll: true })
}

export default function MatchHighlights({ root, data, selection, autoRevealKey, onClear, clearLabel }) {
  const [targets, setTargets] = useState([]), [activeId, setActiveId] = useState(null)
  const lastReveal = useRef(null), previousSelection = useRef(selection)
  const index = targets.findIndex(target => target.dataset.matchId === activeId)
  useEffect(() => {
    const matches = [...(root.current?.querySelectorAll("[data-search-match='true']") || [])]
    setTargets(matches)
    const selectionChanged = previousSelection.current !== selection
    previousSelection.current = selection
    setActiveId(current => !selectionChanged && matches.some(target => target.dataset.matchId === current) ? current : null)
    if (!autoRevealKey) lastReveal.current = null
    if (!autoRevealKey || lastReveal.current === autoRevealKey || !matches.length) return undefined
    const frame = requestAnimationFrame(() => {
      lastReveal.current = autoRevealKey
      setActiveId(matches[0].dataset.matchId)
      reveal(matches[0])
    })
    return () => cancelAnimationFrame(frame)
  }, [root, data, selection, autoRevealKey])
  if (!selection) return null
  const move = next => { setActiveId(targets[next].dataset.matchId); reveal(targets[next]) }
  return <nav className="main-draw-highlights" aria-label="Highlighted matches">
    <span role="status">{targets.length ? `${index < 0 ? "" : `${index + 1} of `}${targets.length} highlighted matches` : "No matching matches in the current draw"}</span>
    <button type="button" className="btn btn-sm btn-light" aria-label="Previous highlighted match" disabled={index <= 0} onClick={() => move(index - 1)}>Previous</button>
    <button type="button" className="btn btn-sm btn-light" aria-label="Next highlighted match" disabled={!targets.length || index >= targets.length - 1} onClick={() => move(index + 1)}>Next</button>
    {onClear ? <button type="button" className="btn btn-sm btn-light" onClick={onClear}>{clearLabel}</button> : null}
  </nav>
}
